import { render, staticRenderFns } from "./SingleArticle.vue?vue&type=template&id=1f8ab21e"
import script from "./SingleArticle.vue?vue&type=script&lang=js"
export * from "./SingleArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports